// @flow
import { combineReducers } from 'redux';
import { AsyncRequest, analyticsActions } from 'angieslist-app-platform';
import { defaultProps } from '../../../app/browser/analyticsDefaultProperties';
import actionKeys from '../../../app/common/service-area/serviceAreaMapActionKeys';

export default (combineReducers({
  serviceArea: AsyncRequest.createReducer(actionKeys.GET_SERVICE_AREA, {
    [actionKeys.GET_SERVICE_AREA_SUCCESS]: (state, action) => state.merge({
      response: {
        advertisingArea: action.payload.find(a => a.requestType === 'advertisingArea').response.body,
        serviceArea: action.payload.find(a => a.requestType === 'serviceArea').response.body,
      },
    }),
    [actionKeys.SET_SERVICE_AREA_SUCCESS]: (state, action) => {
      action.addSideEffect(({ dispatch }) => {
        dispatch(analyticsActions.sendEnhancedTrackEvent({
          name: 'Service Area Saved',
          properties: {
            ...defaultProps,
          },
        }));
      });
      return state.setIn(['response', 'serviceArea', 'postalCodes'], action.meta.postalCodes);
    },
  }),
  citySearch: AsyncRequest.createReducer(actionKeys.SEARCH_CITIES),
  cityDetails: AsyncRequest.createReducer(actionKeys.GET_CITY_DETAILS),
  setServiceArea: AsyncRequest.createReducer(actionKeys.SET_SERVICE_AREA),
}): any);



// WEBPACK FOOTER //
// ./src/modules/store/common/serviceAreaMapReducer.js